import { render, staticRenderFns } from "./ItemElementRenewBtn.vue?vue&type=template&id=95617550&scoped=true"
import script from "./ItemElementRenewBtn.vue?vue&type=script&lang=ts"
export * from "./ItemElementRenewBtn.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementRenewBtn.vue?vue&type=style&index=0&id=95617550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95617550",
  null
  
)

export default component.exports